{
    "ENV": {
        "TITLE": "Lipia | Staging",
        "API": "https://staging.api.lipia.net",
        "WEBSOCKET": "",
        "QR_LOGIN": "",
        "QR_LOGIN_REFRESH_RATE": "",
        "QR_LOGIN_CHECK_RATE": "",
        "MSAL_CLIENT_ID": "",
        "MSAL_TENANT_ID": "",
        "MSAL_AUTHORITY": "",
        "MSAL_KNOWN_AUTHORITIES": "",
        "HAS_VIDEO": "",
        "MAP_KEY": "AIzaSyAOb9xgtKwIE9-PvpytZ7NC3TKZ48zvxKM",
        "MAP_ID": "aa03588413f4c28d",
        "DEBUG": "",
        "EMAIL_LOGIN": "",
        "HIDE_PRIVATE_EMAIL_CHECKBOX": ""
    }
}